module.exports = __webpack_public_path__ + "media/images/territory_landing_pages/hero_banner/component/babysitting-mobile-52aa1046715c636b199b71180d1f31eb.jpg";